<template lang="html">
	<div
		class="activities bg-background relative py-20 md:py-32 overflow-hidden"
	>
		<div class="absolute inset-0 overflow-hidden pointer-events-none">
			<div
				class="absolute w-64 h-64 rounded-full -top-20 -left-20 bg-brand-navy/20 blur-3xl animate-pulse"
			></div>
			<div
				class="absolute delay-1000 rounded-full -bottom-20 -right-20 w-80 h-80 bg-brand-red/20 blur-3xl animate-pulse"
			></div>
		</div>

		<div class="row justify-content-center">
			<div class="col-12 col-md-11 col-lg-10 col-xl-9">
				<div class="row items-center">
					<div class="col-lg-6">
						<div class="row justify-content-md-center">
							<div class="col-lg-11 col-xl-10">
								<div
									class="inline-flex items-center gap-2 px-4 py-2 bg-surface/80 border border-border rounded-full text-sm font-medium text-primary uppercase tracking-wider mb-6 backdrop-blur-sm"
								>
									<div
										class="w-2 h-2 bg-accent rounded-full animate-pulse"
									></div>
									<span>Our Services</span>
								</div>

								<h2
									class="text-4xl lg:text-5xl font-extrabold leading-tight mb-8 relative text-text-primary"
								>
									What we do
								</h2>

								<div class="txt mb-12">
									<p
										class="text-lg lg:text-xl leading-relaxed text-text-secondary"
									>
										We are a solution company that offers
										flexible insurance solution, connecting
										clients and our insurance partners.
									</p>
								</div>

								<div class="flex flex-col gap-6 features-list">
									<div
										class="flex items-center gap-4 p-4 bg-surface border border-border rounded-xl transition-all duration-300 hover:translate-x-2 hover:shadow-lg hover:shadow-primary/10"
									>
										<div
											class="flex items-center justify-center w-10 h-10 bg-primary rounded-lg text-white text-lg"
										>
											<i class="fas fa-shield-alt"></i>
										</div>
										<span
											class="font-medium text-text-primary"
											>Comprehensive Coverage</span
										>
									</div>
									<div
										class="flex items-center gap-4 p-4 bg-surface border border-border rounded-xl transition-all duration-300 hover:translate-x-2 hover:shadow-lg hover:shadow-primary/10"
									>
										<div
											class="flex items-center justify-center w-10 h-10 bg-primary rounded-lg text-white text-lg"
										>
											<i class="fas fa-handshake"></i>
										</div>
										<span
											class="font-medium text-text-primary"
											>Trusted Partnerships</span
										>
									</div>
									<div
										class="flex items-center gap-4 p-4 bg-surface border border-border rounded-xl transition-all duration-300 hover:translate-x-2 hover:shadow-lg hover:shadow-primary/10"
									>
										<div
											class="flex items-center justify-center w-10 h-10 bg-primary rounded-lg text-white text-lg"
										>
											<i class="fas fa-chart-line"></i>
										</div>
										<span
											class="font-medium text-text-primary"
											>Flexible Solutions</span
										>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="col-lg-6">
						<div
							class="text-center pt-10 lg:pt-0 relative image-box"
						>
							<div class="relative inline-block image-container">
								<div
									class="absolute top-8 left-8 right-[-2rem] bottom-[-2rem] bg-primary/10 rounded-2xl z-0"
								></div>
								<img
									src="img/shape-image.png"
									srcset="
										img/shape-image@2x.png 2x,
										img/shape-image@3x.png 3x
									"
									class="w-11/12 h-auto relative z-10 rounded-3xl shadow-xl shadow-gray-400/20 transition-transform duration-300 hover:scale-105"
								/>
								<div
									class="floating-element element-1 absolute flex items-center justify-center w-12 h-12 bg-accent rounded-full text-white text-xl shadow-lg shadow-accent/30"
									style="
										top: 10%;
										right: 10%;
										animation-delay: 0s;
									"
								>
									<i class="fas fa-umbrella"></i>
								</div>
								<div
									class="floating-element element-2 absolute flex items-center justify-center w-12 h-12 bg-accent rounded-full text-white text-xl shadow-lg shadow-accent/30"
									style="
										bottom: 20%;
										left: 5%;
										animation-delay: 1s;
									"
								>
									<i class="fas fa-heart"></i>
								</div>
								<div
									class="floating-element element-3 absolute flex items-center justify-center w-12 h-12 bg-accent rounded-full text-white text-xl shadow-lg shadow-accent/30"
									style="
										top: 50%;
										right: 5%;
										animation-delay: 2s;
									"
								>
									<i class="fas fa-car"></i>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
export default {
	components: {},
	computed: {
		...mapGetters([]),
	},
	methods: {
		...mapActions([]),
	},
	mounted() {},
};
</script>

<style lang="less">
// Minimal CSS retained for non-utility-class functionality like keyframes

// Media query adjustments for smaller screens
@media (max-width: 768px) {
	.activities {
		padding: 3rem 0 2rem 0 !important;
	}

	.features-list {
		flex-direction: column !important;
		gap: 1rem !important;
	}

	.image-container {
		margin-top: 3rem;
	}
}

// Keyframe for the simple floating animation
@keyframes float {
	0%,
	100% {
		transform: translateY(0px);
	}
	50% {
		transform: translateY(-10px);
	}
}

.floating-element {
	animation: float 3s ease-in-out infinite;
}

// Keyframe for the simple pulse animation
@keyframes pulse {
	0%,
	100% {
		opacity: 1;
	}
	50% {
		opacity: 0.5;
	}
}

.animate-pulse {
	animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
</style>
